import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";
import { TrainsInfo } from "@core/models/trainsInfo";
import {
  LanguageService,
  TrainService,
  UtilsService,
} from "@core/services";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-trains-summary",
  templateUrl: "./trains-summary.component.html",
  styleUrls: ["./trains-summary.component.scss"],
})
export class TrainsSummaryComponent implements OnInit {
  @Input() activePage: string = 'result';
  @Input() onView: string = 'depart';
  @Input() stepper: MatStepper;
  trainsInfo: TrainsInfo;
  @Output() onSelectTrainsEvent = new EventEmitter<any>();
  @Output() onSearchReturnEvent = new EventEmitter<any>();
  @Output() onViewDepartEvent = new EventEmitter<any>();
  @Output() onSelectExtrasEvent = new EventEmitter<any>();
  @Output() navigateEvent = new EventEmitter<any>();

  constructor(
    public trainService: TrainService,
    private translate: TranslateService,
    private langService: LanguageService,
    public utilsService: UtilsService
  ) {
    this.trainService.getTrainsInfo$().subscribe((info: TrainsInfo) => {
      this.trainsInfo = info;
    });
  }

  ngOnInit(): void {
  }

  goNextStep() {
    this.stepper.next();
  }

  cancel() {
    history.back();
  }

getSelectedAlternative(section: any, selectedAlternatives: any[]) {
  return section.alternatives.find(a =>
    selectedAlternatives?.includes(a.alternativeId)
  );
}

  formatDate(date: string): string {
    return new Date(date).toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long'
    });
  }

  onSelectTrains() {
    this.onSelectTrainsEvent.emit();
  }

  onViewDepart() {
    this.onViewDepartEvent.emit();
  }

  onSearchReturn() {
    this.onSearchReturnEvent.emit();
  }

  onSelectExtras() {
    this.onSelectExtrasEvent.emit();
  }

  isPriceWithinRangeMethod(): boolean {
    let price: number = Number(this.trainService.calculateFinalPrice(this.trainsInfo))
    if (
      !this.trainsInfo.userFilters ||
      this.trainsInfo.userFilters?.priceMinTrain == null ||
      this.trainsInfo.userFilters?.priceMaxTrain == null
    ) {
      return true;
    }

    return (
      price >= this.trainsInfo.userFilters.priceMinTrain &&
      price <= this.trainsInfo.userFilters.priceMaxTrain
    );
  }

  getInvalidString(): string {
    let response: string = ``;

    const keys = [
      "flight.result-flight.form.name",
      "flight.result-flight.form.surname",
      "flight.result-flight.form.lastSurname",
      "flight.result-flight.form.birthDate",
      "flight.result-flight.form.phoneNumber",
      "flight.result-flight.form.documentNumber",
      "flight.result-flight.form.documentType",
      "flight.result-flight.form.fillForContinue",
      "flight.form-flight.passenger",
      "user.form.invalid-birthdate",
    ];
    this.translate.get(keys).subscribe((result) => {
      this.trainsInfo.travellersForm.controls.forEach((formControl: UntypedFormGroup) => {
        if (formControl.invalid) {
          response += ` ${result["flight.form-flight.passenger"]} Nº ${this.trainsInfo.travellersForm.controls.indexOf(formControl) + 1
            }  ${result["flight.result-flight.form.fillForContinue"]} `;
        }
        let invalids = Object.keys(formControl.controls).filter(
          (key) => formControl.controls[key].invalid
        );
        invalids.forEach((key, index) => {
          switch (key) {
            case "name":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.name"]}.`;
              } else {
                response += `${result["flight.result-flight.form.name"]},`;
              }
              break;
            case "surname":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.surname"]}.`;
              } else {
                response += `${result["flight.result-flight.form.surname"]}, `;
              }
              break;
            case "lastSurname":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.lastSurname"]}. `;
              } else {
                response += `${result["flight.result-flight.form.lastSurname"]}, `;
              }
              break;
            case "birthdate":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.birthDate"]}. `;
              } else {
                response += `${result["flight.result-flight.form.birthDate"]}, `;
              }
              break;
            case "phone":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.phoneNumber"]}. `;
              } else {
                response += `${result["flight.result-flight.form.phoneNumber"]}, `;
              }
              break;
            case "documentNumber":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.documentNumber"]}. `;
              } else {
                response += `${result["flight.result-flight.form.documentNumber"]}, `;
              }
              break;
            case "documentType":
              if (invalids[index] === invalids[invalids.length - 1]) {
                response += `${result["flight.result-flight.form.documentType"]}. `;
              } else {
                response += `${result["flight.result-flight.form.documentType"]}, `;
              }
              break;
            default:
              break;
          }
        });
      });
    });
    return response;
  }

  getWaitDuration(train, i: number) {
    const actualSection = train.sections[i]
    const nextSection = train.sections[i+1]
    const date1 = new Date(nextSection.departDate);
    const date2 = new Date(actualSection.arriveDate);

    const diffMs = Math.abs(date1.getTime() - date2.getTime()); // diferencia en milisegundos

    const diffHrs = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMin = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    return `${diffHrs} h ${diffMin} min`;
  }

  getSeatText(seat) {
    if (this.langService.getLanguage() === 'es') {
      if (seat.carriage.includes('silent carriage')) {
        return "Vagón " + seat.carriage.split(" - silent carriage")[0] + " - silencioso " + ", asiento " + seat.position
      }
      return "Vagón " + seat.carriage + ", asiento " + seat.position
    } else {
      return "Wagon" + seat.carriage + ", seat " + seat.position
    }
  }

}
